import { useState } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import Dashboard from './component/Dashboard';
import Login from './component/Login';
import ThankYou from './ThankYou';

const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';

function App() {
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState<string>(() => {
    try {
      return localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) ?? '';
    } catch {
      return '';
    }
  });

  const handleLoginSuccess = (token: string) => {
    try {
      localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
    } catch {
      // localStorage can fail in restricted browser modes.
    }
    setAccessToken(token);
    navigate('/dashboard', { replace: true });
  };

  const handleLogout = () => {
    try {
      localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
    } catch {
      // localStorage can fail in restricted browser modes.
    }
    setAccessToken('');
    navigate('/login', { replace: true });
  };

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route
        path="/login"
        element={accessToken ? <Navigate to="/dashboard" replace /> : <Login onLoginSuccess={handleLoginSuccess} />}
      />
      <Route
        path="/dashboard"
        element={accessToken ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />}
      />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
